import { render } from "./InstitutePayment.vue?vue&type=template&id=30e0086b&scoped=true"
import script from "./InstitutePayment.vue?vue&type=script&lang=js"
export * from "./InstitutePayment.vue?vue&type=script&lang=js"

import "./InstitutePayment.vue?vue&type=style&index=0&id=30e0086b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e0086b"]])

export default __exports__